import { z } from "zod";

type Id = string;
const idZodSchema = z.string().min(5);
const genericIdZodSchema = <T extends string>() =>
    idZodSchema as unknown as z.ZodType<T>;

export { genericIdZodSchema, idZodSchema };
export type { Id };
